import { create } from 'zustand';
import { emit } from '@/lib/events';
import type { PoiCategory } from './types';

interface PoiState {
  active: ReadonlySet<PoiCategory>;
  toggle: (cat: PoiCategory) => void;
  setMany: (cats: PoiCategory[]) => void;
}

export const usePoiStore = create<PoiState>((set, get) => ({
  active: new Set<PoiCategory>(),
  toggle: (cat) => {
    const next = new Set(get().active);
    const wasOn = next.has(cat);
    if (wasOn) next.delete(cat);
    else next.add(cat);
    set({ active: next });
    emit('poi:toggled', { category: cat, on: !wasOn });
  },
  setMany: (cats) => {
    const prev = get().active;
    const next = new Set(cats);
    set({ active: next });
    // Emit отдельные события только для изменившихся категорий
    for (const c of next) if (!prev.has(c)) emit('poi:toggled', { category: c, on: true });
    for (const c of prev) if (!next.has(c)) emit('poi:toggled', { category: c, on: false });
  },
}));
